/* eslint-disable */
<template>
  <div class="admin_bookings_awaiting_consent">
    <AdminNavigation ref="navigation" indexProps="5" />
    <div class="top-panel">
      <Header />
      <div class="header-title-section">
        <div class="header-title"><h1>Admin Workflow</h1></div>
        <div class="header-sub-title"></div>
      </div>
    </div>
    <div class="panel">
      <AdminBookingsMenu :key="bookingMenuIndex" :indexProps="bookingMenuIndex" />
      <div class="content">
        <div class="tool-bar row">
          <div class="col">
            <div class="icon-group right-float-element">
              <el-input style="max-width: 120px" class="mr-1" @input="search()" clearable placeholder="Booking ID" v-model="listParam.BookingID"/>
              <el-input style="max-width: 160px" class="mr-1" @input="search()" clearable placeholder="Examinee Name" v-model="listParam.ClaimantName"/>
              <el-input style="max-width: 160px" class="mr-1" @input="search()" clearable placeholder="Client Name" v-model="listParam.ClientName"/>
              <el-input style="max-width: 160px" class="mr-1" @input="search()" clearable placeholder="Specialist Name" v-model="listParam.SpecialistName"/>
<!--              <el-input style="max-width: 160px" class="mr-1" @input="search()" clearable placeholder="Assigned To" v-model="listParam.AssignedToName"/>-->
              <el-date-picker
                  style="width: 290px"
                  v-model="dateValue"
                  type="daterange"
                  :picker-options="pickerOptions"
                  start-placeholder="Booking Date Start"
                  popper-class="date-range-picker-popper"
                  value-format="yyyy-MM-dd"
                  format="dd/MM/yyyy"
                  @change="changeDates"
                  end-placeholder="Booking Date End"
                  clearable
              />
            </div>
          </div>
        </div>

        <div class="content-scroll-x">
          <div>
            <div :class="bookings.length > 5 ? 'content-scroll-y' : ''">
              <el-table @row-click="RowClick" ref="bookingTable" :default-sort="{prop: 'BookingID', order: 'descending'}" stripe @sort-change="sortParam" :data="bookingUnconfirmed" tooltip-effect="dark" :header-row-style="{background: '#fde9eb', height: '70px'}" :header-cell-style="{fontWeight: 100}">
                <el-table-column
                    width="100"
                    prop="BookingID"
                    label="ID"
                    sortable="custom"
                    show-overflow-tooltip
                    fixed="left"
                >
                </el-table-column>
                <el-table-column
                    width="150"
                    sortable="custom"
                    show-overflow-tooltip
                    label="Examinee"
                    prop="ClaimantFullName"
                >
                </el-table-column>
                <el-table-column
                    width="150"
                    show-overflow-tooltip
                    prop="BookingDateTime"
                    sortable="custom"
                    label="Booking Date"
                >
                  <template slot-scope="scope">
                    <span>{{
                        formatDate(scope.row.BookingDateTime, "DD/MM/YYYY HH:mm")
                      }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    width="280"
                    prop="BookingType"
                    label="Service Type"
                    sortable="custom"
                >
                  <template slot-scope="booking">
                    <span>{{ decodeURIComponent(booking.row.BookingType.BookingTypeName)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="140"
                    show-overflow-tooltip
                    prop="DeliveryMethodID"
                    label="Delivery Method"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.DeliveryMethodID">{{
                        scope.row.DeliveryMethodID === 1 ? 'In-person' : 'Virtual'
                      }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="150"
                    show-overflow-tooltip
                    prop="Client"
                    sortable="custom"
                    label="Client"
                >
                  <template slot-scope="booking">
                    <span>{{booking.row.Case && booking.row.Case.Client && decodeURIComponent(booking.row.Case.Client.ClientName)}} - {{decodeURIComponent(booking.row.Case.Client.BranchName)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="150"
                    show-overflow-tooltip
                    prop="Specialist"
                    label="Specialist"
                    sortable="custom"
                >
                  <template slot-scope="booking">
                    <span>{{booking.row.Specialist && decodeURIComponent(booking.row.Specialist.Title + ' ' + booking.row.Specialist.FirstName + ' ' + booking.row.Specialist.Surname)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="200"
                    prop="custom"
                    label="Paperwork Status"
                    show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <div class="d-flex align-items-center">
                      <el-tooltip  effect="dark" content="Paperwork Processed" placement="bottom">
                        <img
                            class="ml-4 is-icon"
                            src="@/assets/images/paperwork-processed.svg"
                            :class="isDate(scope.row.PaperworkProcessed) ? '' : 'disabled-element'"
                        />
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                    width="200"
                    prop="custom"
                    show-overflow-tooltip
                >
                  <template slot="header">
                    <div class="d-flex align-items-center">
                      <span>Booking Details</span>
                      <img v-if="listParam.orderBy !== 'ClaimantConfirmed' && listParam.orderBy !== 'RedHealthMayContactClaimant' && listParam.orderBy !== 'ClaimantConsentReceived'  && listParam.orderBy !== 'VideoLinkTestStatus'" id="ClaimantConfirmed" @click="customSort($event)"
                           class="is-icon w-10 ml-2"
                           src="@/assets/images/menu4.svg"
                      />
                      <img v-if="listParam.orderBy === 'ClaimantConfirmed'" id="RedHealthMayContactClaimant" @click="customSort($event)"
                           class="is-icon w-10 ml-2"
                           src="@/assets/images/menu4-1.svg"
                      />
                      <img v-if="listParam.orderBy === 'RedHealthMayContactClaimant'" id="ClaimantConsentReceived" @click="customSort($event)"
                           class="is-icon w-10 ml-2"
                           src="@/assets/images/menu4-2.svg"
                      />
                      <img v-if="listParam.orderBy === 'ClaimantConsentReceived'" id="VideoLinkTestStatus" @click="customSort($event)"
                           class="is-icon w-10 ml-2"
                           src="@/assets/images/menu4-3.svg"
                      />
                      <img v-if="listParam.orderBy === 'VideoLinkTestStatus'" id="BookingID" @click="customSort($event)"
                           class="is-icon w-10 ml-2"
                           src="@/assets/images/menu4-4.svg"
                      />
                    </div>
                  </template>
                  <template slot-scope="scope">
                    <div class="d-flex align-items-center">
                      <el-tooltip effect="dark" :content="getAttendanceTitle(scope.row)" placement="bottom">
                        <img
                            class="is-icon"
                            style="width: 34px"
                            src="@/assets/images/claimant_attendance_icon.svg"
                            :class="isDate(scope.row.ClaimantConfirmed) || scope.row.ClaimantConfirmed ? '' : 'disabled-element'"
                        />
                      </el-tooltip>
                      <el-tooltip effect="dark" :content="getCanRingClaimantTitle(scope.row)" placement="bottom">
                        <img
                            class="ml-2 is-icon"
                            style="width: 34px"
                            src="@/assets/images/can_ring_claimant_icon.svg"
                            :class="scope.row.RedHealthMayContactClaimant ? '' : 'disabled-element'"
                        />
                      </el-tooltip>
                      <el-tooltip effect="dark" :content="getConsentReceivedTitle(scope.row)" placement="bottom">
                        <img
                            class="ml-2 is-icon"
                            style="width: 34px"
                            src="@/assets/images/consent_received_icon.svg"
                            :class="isDate(scope.row.ClaimantConsentReceived) || scope.row.ClaimantConsentReceived ? '' : 'disabled-element'"
                        />
                      </el-tooltip>
                    <el-tooltip effect="dark" :content="getHasVideoTitle(scope.row)" placement="bottom">
                      <img
                          v-if="scope.row.VideoLink"
                          class="ml-2 is-icon"
                          src="@/assets/images/video_link_test_icon.svg"
                          style="width: 34px"
                          :class="scope.row.VideoLinkTestStatus === 2 ? '' : 'disabled-element'"
                      />
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                    width="150"
                    show-overflow-tooltip
                    label="ZohoAdminOwner"
                    prop="ZohoAdminOwner"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <div v-if="totalCount > listParam.pageSize" class="pagination">
          Page
          <div class="pagination-group">
            <div class="border-icon pagination-current dropdown">
              <div class="pagination-current-text">{{ listParam.pageNum }}</div>
              <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true"
                   aria-expanded="false"></div>
              <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :key="item"
                     :class="listParam.pageNum === item ? 'selected' : ''" :value="item" @click="selectPage(item)">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount / listParam.pageSize) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from "@/assets/js/utilities"
import AdminNavigation from "@/components/AdminNavigation"
import AdminBookingsMenu from "@/components/AdminBookingsMenu"
import Header from "@/components/Header"
import { debounce } from 'lodash';

export default {
  name: "AdminBookingsAwaitingConsent",
  components: {
    AdminNavigation,
    AdminBookingsMenu,
    Header,
  },
  data() {
    return {
      dateValue: '',
      bookings: [],
      allBookings: [],
      limit: 10,
      users: [],
      totalCount: 0,
      pagination: utilities.initPagination(),
      bookingMenuIndex: 10,
      bookingUnconfirmed: [],
      allBookingUnconfirmed: [],
      loading: false,
      listParam: {
        pageSize: 10,
        pageNum: 1,
        orderBy: 'BookingID',
        BookingID: null,
        ascOrDesc: 'DESC',
        ClientName: '',
        ClaimantName: '',
        SpecialistName: '',
        AssignedToName: ''
      },
      userParam: {
        pageSize: 10,
        pageNum: 1,
        orderBy: 'UserStatus',
        ascOrDesc: 'DESC',
        UserName: null,
        UserRoleID: '3,6'
      },
      pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Number(window.moment().startOf('day').format('x'));
        },
      },
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
  },
  methods: {
    search: debounce(function () {
      this.selectPage(1)
    }, 800),
    changeDates(v) {
      if(v) {
        this.listParam.FromDate = v[0]
        this.listParam.ToDate = v[1]
      } else {
        this.listParam.FromDate = null
        this.listParam.ToDate = null
      }
      this.selectPage(1)
    },
    getHasVideoTitle(booking) {
      const title = "Video link test " + (booking.VideoLinkTestStatus == 2 ? "" : "not ") + "completed"
      return title
    },
    getAttendanceTitle(booking) {
      const title = "Examinee attendance " + (this.isDate(booking.ClaimantConfirmed) || booking.ClaimantConfirmed ? "" : "not ") + "confirmed"
      return title
    },
    isDate(date) {
      return moment(date, "YYYY-MM-DD").isValid()
    },
    RowClick(row, col) {
      if(col.property === 'custom' || col.property === 'AssignedToName') return
      this.openBooking(row?.id)
    },
    customSort(sort) {
      this.listParam.orderBy = sort.target.id
      this.listParam.ascOrDesc = 'DESC'
      this.selectPage(1)
    },

    sortParam( v ) {
      if(v.prop === 'id' && v.order === "ascending") {
        this.listParam.orderBy = 1
      } else if (v.prop === 'id' && v.order === "descending") {
        this.listParam.orderBy = 2
      } else if(v.prop === 'claimantFullName' && v.order === "ascending") {
        this.listParam.orderBy = 3
      } else if (v.prop === 'claimantFullName' && v.order === "descending") {
        this.listParam.orderBy = 4
      } else if(v.prop === 'dateCreated' && v.order === "ascending") {
        this.listParam.orderBy = 15
      } else if (v.prop === 'dateCreated' && v.order === "descending") {
        this.listParam.orderBy = 16
      } else if(v.prop === 'booingDate' && v.order === "ascending") {
        this.listParam.orderBy = 5
      } else if (v.prop === 'booingDate' && v.order === "descending") {
        this.listParam.orderBy = 6
      } else if(v.prop === 'clientName' && v.order === "ascending") {
        this.listParam.orderBy = 7
      } else if (v.prop === 'clientName' && v.order === "descending") {
        this.listParam.orderBy = 8
      } else if(v.prop === 'contactFullName' && v.order === "ascending") {
        this.listParam.orderBy = 3
      } else if (v.prop === 'contactFullName' && v.order === "descending") {
        this.listParam.orderBy = 4
      } else if(v.prop === 'specialistFullName' && v.order === "ascending") {
        this.listParam.orderBy = 9
      } else if (v.prop === 'specialistFullName' && v.order === "descending") {
        this.listParam.orderBy = 10
      } else if (v.prop === 'bookingTypeName' && v.order === "descending") {
        this.listParam.orderBy = 28
      } else if (v.prop === 'bookingTypeName' && v.order === "ascending") {
        this.listParam.orderBy = 27
      } else if (v.prop === 'assignedToName' && v.order === "descending") {
        this.listParam.orderBy = 26
      } else if (v.prop === 'assignedToName' && v.order === "ascending") {
        this.listParam.orderBy = 25
      }
      this.selectPage(1)
    },
    selectPage(index) {
      this.listParam.pageNum = index
      this.loadData()
    },

    getCanRingClaimantTitle(booking) {
      var title = booking.RedHealthMayContactClaimant ? "Can ring claimant" : "Can not ring claimant"
      return title
    },

    getConsentReceivedTitle(booking) {
      const title = "Examinee consent " + (this.isDate(booking.ClaimantConsentReceived) || booking.ClaimantConsentReceived ? "" : "not ") + "received"
      return title
    },

    async changeAssignedTo(row) {
      // Change status to assigned
      const result = await this.putBookingRequest(row)
      if (result) {
        this.$notify({
          dangerouslyUseHTMLString: true,
          message: '<div class="alert-success">' +
              '            <b>Success:</b> Booking updated !' +
              '          </div>',
        });
      }
    },

    putBookingRequest(row) {
      this.$store.dispatch('loading/setLoadComponent', true)
      const params = {
        UserID: this.user.id,
        Username: this.user.name,
        BookingID: row.id,
        AvailabilityID: row?.specialistAvailabilityId,
        AssignedTo: Number(row.assignedTo),
        BookingTypeID: row.bookingTypeId,
        BookingDateTime: utilities.formatDate(row.bookingDateTime, "YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD HH:mm"),
        BookingEndTime: window.moment(row.bookingEndTime, 'HH:mm:ss').format('HH:mm:ss')
      }
      var callback = () => {
        // Reload if change to Completed
        this.selectPage(this.listParam.pageNum)
        this.$store.dispatch('loading/setLoadComponent', false)
      }
      return utilities.putBooking(params, callback, true)
    },

    formatDate(dateToFormat, newFormat, currentFormat = "") {
      return utilities.formatDate(dateToFormat, newFormat, currentFormat)
    },

    openBooking(id) {
      let routeData = this.$router.resolve({ path: '/admin-manage-booking', query: { id: id } })
      window.open(routeData.href, '_blank')
    },

    async loadData() {
      await this.$store.dispatch("loading/setLoadComponent", true)
      let obj = {...this.listParam}
      for (let key in obj) {
        if (obj[key] === null || obj[key] === '') {
          delete obj[key];
        }
      }
      const {bookings, total} = await utilities.getBookingUnconfirmedNew(obj)
      this.totalCount = total
      this.bookingUnconfirmed = _.cloneDeep(bookings)
      // this.bookingUnconfirmed.filter(item => item.assignedTo).forEach(item => {
      //   if(this.users.filter(user => user.id === item.assignedTo).length === 0) {
      //     this.users.push({id: item.assignedTo, name: decodeURIComponent(item.assignedToName)})
      //   }
      // })
      await this.$store.dispatch("loading/setLoadComponent", false)
    },
    async loadUser() {
      var {users} = await utilities.getUsersNew(this.userParam)
      let arr = users.filter(item => item.status)
      for(let i = 0; i < arr.length; i++) {
        if(!this.users.find(item => item.id === arr[i].id)) {
          this.users.unshift(arr[i])
        } else {
          let index = this.users.findIndex(item => item.id === arr[i].id)
          this.users.splice(index, 1)
          this.users.unshift(arr[i])
        }
      }
    },
  },
  async beforeMount() {
    this.$store.dispatch("loading/setLoadComponent", true)
    // await this.loadUser()
    await this.loadData()
    this.$store.dispatch("loading/setLoadComponent", false)
  },
  mounted() {
    $(".pagination").hide()
  },
}
</script>
